import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { exchangeSession } from "@/lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    exchangeSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((e) => setError(e?.response?.data?.detail || "Sign-in failed"));
  }, [location.hash, navigate]);

  return (
    <main className="grid min-h-screen place-items-center px-6" data-testid="auth-callback">
      {error ? (
        <div className="max-w-md rounded-3xl border border-[var(--line)] bg-white p-8 text-center">
          <p className="font-display text-xl font-bold text-[var(--red)]" data-testid="auth-error">{error}</p>
          <p className="mt-3 text-sm text-[var(--ink-2)]">Only approved Google accounts can open the inquiry dashboard.</p>
          <a href="/" className="btn-ghost mt-6">Back to site</a>
        </div>
      ) : (
        <Loader2 className="animate-spin text-[var(--green)]" />
      )}
    </main>
  );
};
